import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { QRCodeSVG } from 'qrcode.react';
import SignatureCanvas from 'react-signature-canvas';
import { Loader2, Trash2 } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { API } from '@/utils/api';

export const FUEL = ['Réserve', '1/4', '1/2', '3/4', 'Plein'];

export const FuelPicker = ({ value, onChange, prefix }) => (
  <div className="flex gap-1.5 mt-1">{FUEL.map(l => (
    <button key={l} type="button" onClick={() => onChange(l)} data-testid={`${prefix}-fuel-${l.replace('/', '-')}`}
      className={`flex-1 py-2 rounded-lg text-sm font-semibold border transition-colors ${value === l ? 'bg-slate-900 text-white border-slate-900' : 'border-slate-300 hover:border-slate-900'}`}>{l}</button>
  ))}</div>
);

export const SignatureField = ({ sigRef, name, onName, prefix, label = 'Signature du client' }) => (
  <div>
    <div className="flex items-center justify-between"><Label>{label}</Label>
      <button type="button" className="text-xs text-slate-500 flex items-center gap-1 hover:text-red-600" onClick={() => sigRef.current?.clear()} data-testid={`${prefix}-signature-clear`}><Trash2 className="w-3 h-3" />Effacer</button></div>
    <div className="border-2 rounded-lg bg-slate-50 mt-1" data-testid={`${prefix}-signature-pad`}><SignatureCanvas ref={sigRef} penColor="#0E1116" canvasProps={{ className: 'w-full h-32' }} /></div>
    <Input className="mt-2 h-9" value={name} onChange={e => onName(e.target.value)} placeholder="Nom du signataire" data-testid={`${prefix}-signer-input`} />
  </div>
);

export const sigData = (ref) => (ref.current && !ref.current.isEmpty() ? ref.current.getCanvas().toDataURL('image/png') : '');

export const PhoneQrPanel = ({ apptId, kind, path, title, steps, doneMsg, onDone }) => {
  const [token, setToken] = useState(null);
  const [error, setError] = useState('');
  const doneKey = kind === 'checkout' ? 'checked_out' : 'checked_in';
  useEffect(() => {
    axios.post(`${API}/agenda/appointments/${apptId}/mobile-${kind}`).then(r => setToken(r.data.token))
      .catch(e => setError(e.response?.data?.detail || 'QR code indisponible'));
    const t = setInterval(() => axios.get(`${API}/agenda/appointments/${apptId}/checkin-status`)
      .then(r => { if (r.data[doneKey]) { clearInterval(t); toast.success(doneMsg); onDone(); } }).catch(() => {}), 3000);
    return () => clearInterval(t);
  }, [apptId]); // eslint-disable-line react-hooks/exhaustive-deps
  const url = token ? `${window.location.origin}${path}?t=${token}` : '';
  return (
    <div className="flex items-center gap-4 p-3 rounded-xl border-2 border-[#FACC15] bg-[#0E1116] text-white" data-testid={`${kind}-phone-panel`}>
      <div className="bg-white p-2 rounded-lg w-36 h-36 flex items-center justify-center shrink-0">
        {url ? <QRCodeSVG value={url} size={128} data-testid={`${kind}-phone-qr`} /> : error ? <span className="text-xs text-red-600">{error}</span> : <Loader2 className="w-6 h-6 animate-spin text-slate-400" />}
      </div>
      <div className="text-sm space-y-1">
        <p className="font-bold text-[#FACC15] text-base">{title}</p>
        <ol className="list-decimal ml-4 text-slate-200 space-y-0.5">{steps.map(s => <li key={s}>{s}</li>)}</ol>
        <p className="text-xs text-slate-400 flex items-center gap-1"><Loader2 className="w-3 h-3 animate-spin" />Cette fenêtre se met à jour toute seule</p>
        {url && <a href={url} target="_blank" rel="noopener noreferrer" className="text-xs underline text-slate-400" data-testid={`${kind}-phone-link`}>Ouvrir le lien</a>}
      </div>
    </div>
  );
};
